import MigrationRunBar from './MigrationRunBar';

export default MigrationRunBar;
